import {
  Component,
  EventEmitter,
  Input,
  Output,
  Type,
  ViewChild,
  computed,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { AbstractControl, FormGroup } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { LoaderIndicatorDirective, LoaderService } from '@t-llevo/common-ui';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogLoaderService } from '../../services/dialog-loader/dialog-loader.service';
import { MatNativeDateModule } from '@angular/material/core';
import { BaseDialogStepperFormComponent } from '../../base-dialog-stepper-form';

type Step = {
  label: string;
  component: Type<BaseDialogStepperFormComponent<AbstractControl<unknown>>>;
  controlName: string;
};

@Component({
  selector: 't-llevo-dialog-stepper-form',
  standalone: true,
  imports: [
    CommonModule,
    DialogHeaderComponent,
    MatDialogModule,
    MatStepperModule,
    MatButtonModule,
    LoaderIndicatorDirective,
    MatNativeDateModule,
  ],
  templateUrl: './dialog-stepper-form.component.html',
  styleUrl: './dialog-stepper-form.component.css',
  providers: [LoaderService, DialogLoaderService],
})
export class DialogStepperFormComponent {
  @Input({ required: true }) dialogTitle!: string;
  steps = input.required<Step[]>();
  @Input({ required: true }) frm!: FormGroup;
  @Input() isLinear: boolean = false;
  @Input() set isStepperLoading(value: boolean) {
    if (value) {
      this.loaderSrv.show(this.loaderId);
    } else {
      this.loaderSrv.hide(this.loaderId);
    }
  }

  @Output() dataSubmit = new EventEmitter();

  @ViewChild(MatStepper) protected stepper!: MatStepper;

  protected loaderSrv = inject(DialogLoaderService);
  protected loading$ = toSignal(this.loaderSrv.loaderState$);
  private loaderId = this.loaderSrv.subscribe();

  selectedStepIndex = 0;
  stepperLastIndex = computed(() => this.steps().length - 1);

  selectNextStep() {
    this.stepper.selected?._markAsInteracted();

    const stepIndex = this.stepper.selectedIndex;
    const frmKeys = Object.keys(this.frm.controls);
    this.frm.controls[frmKeys[stepIndex]].markAllAsTouched();

    if (this.stepper.selected?.completed) {
      this.stepper.selectedIndex == this.selectedStepIndex++;
    }
  }

  selectPreviusStep() {
    this.stepper.previous();
  }

  onSubmit() {
    this.stepper.selected?._markAsInteracted();
    if (this.frm.valid) {
      return this.dataSubmit.emit(this.frm.getRawValue());
    }
  }

  getFormControl(controlName: string) {
    return this.frm.controls[controlName];
  }
}
